import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'

import Actions from '@/components/Actions'
Vue.component('Actions', Actions)

Vue.config.productionTip = false
Vue.mixin({
  methods: {
    copy(data) {
      let input = document.createElement('input')
      input.value = data
      input.id = 'inp'
      document.body.appendChild(input)
      let text = document.getElementById('inp')
      text.select()
      document.execCommand('copy')
      text.remove()
    },
    download(text) {
      var element = document.createElement('a')
      element.setAttribute(
        'href',
        'data:text/plain;charset=utf-8,' + encodeURIComponent(text)
      )
      element.setAttribute('download', 'result.txt')

      element.style.display = 'none'
      document.body.appendChild(element)

      element.click()

      document.body.removeChild(element)
    }
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
